/*
  Caramel — en la página de carrito ampliado (body.template-cart),
  assets/theme.js NO inicializa theme.CartDrawer a propósito:

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.settings.cartType === 'drawer') {
        if (!document.body.classList.contains('template-cart')) {
          new theme.CartDrawer();
        }
      }
      ...
    }

  Como consecuencia, el icono del carrito del header (clase
  .js-drawer-open-cart, en snippets/header-icons.liquid) no tiene ningún
  listener de apertura de drawer enganchado en esa página, así que el
  clic simplemente sigue su href normal hacia routes.cart_url — que es
  la propia página en la que ya estás, así que no pasa nada visible.

  Aquí inicializamos theme.CartDrawer manualmente en esa página para que
  el icono abra el carrito lateral ("modo caja") por encima del carrito
  ampliado, igual que hace en el resto del sitio. theme.CartDrawer usa
  theme.cart.getCartProductMarkup() (AJAX) para pintar el contenido, así
  que no depende de qué página lo dispare y queda sincronizado con el
  carrito real. #CartDrawer / #CartDrawerForm ya existen en el DOM en
  esta página porque snippets/cart-drawer.liquid se renderiza siempre
  desde sections/header.liquid (el propio snippet comprueba settings.cart_type
  puertas adentro), independientemente del template.

  No toca nada de la página de carrito en sí (el theme.CartForm del
  #CartPageForm sigue funcionando exactamente igual, son dos formularios
  y dos instancias de CartForm totalmente independientes).

  2026-07-23
*/
(function () {
  function maybeInitCartDrawer() {
    if (
      !document.body.classList.contains('template-cart') ||
      !window.theme ||
      !theme.settings ||
      theme.settings.cartType !== 'drawer' ||
      !theme.CartDrawer ||
      theme.CartDrawer.__caramelInstance
    ) {
      return;
    }

    theme.CartDrawer.__caramelInstance = new theme.CartDrawer();
  }

  // theme.js se carga con defer justo antes que este script, así que en
  // condiciones normales ya ha corrido su propio DOMready(...) (que es
  // síncrono si el documento ya no está en 'loading', que es el caso
  // normal para scripts defer). El fallback cubre cualquier caso de
  // carga fuera de lo habitual.
  if (document.readyState !== 'loading') {
    maybeInitCartDrawer();
  } else {
    document.addEventListener('DOMContentLoaded', maybeInitCartDrawer);
  }
})();
